// extracted by mini-css-extract-plugin
export default {"scrollbar-v":"scrollbar-tab_scrollbar-v__rf7by","scrollbar-v-tabs":"scrollbar-tab_scrollbar-v-tabs__Dg9o9","scroll":"scrollbar-tab_scroll__GoMcy"};